import { cn } from '@/shared/utils/cn'

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Width — can be a Tailwind class like "w-32" or inline style */
  width?: string | number
  /** Height — can be a Tailwind class like "h-4" or inline style */
  height?: string | number
  /** Rounded — defaults to 'md' */
  rounded?: 'sm' | 'md' | 'lg' | 'full'
}

const roundedMap = {
  sm: 'var(--r-sm)',
  md: 'var(--r-md)',
  lg: 'var(--r-lg)',
  full: '9999px',
}

export function Skeleton({ className, width, height, rounded = 'md', style, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('animate-pulse', className)}
      style={{
        backgroundColor: 'var(--surface-2)',
        borderRadius: roundedMap[rounded],
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        ...style,
      }}
      aria-hidden="true"
      {...props}
    />
  )
}

/** Pre-built skeleton for text lines */
export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          height={14}
          style={{ width: i === lines - 1 ? '66%' : '100%' }}
          rounded="sm"
        />
      ))}
    </div>
  )
}
